import React from 'react';
import NavigationComponent from '../../commonComponents/util/NavigationComponent';
import HoverTableRow from '../../commonComponents/util/HoverTableRow';
import ValidatedInput from '../../commonComponents/util/ValidatedInput';
import CurrencyFormatInput from '../../commonComponents/util/CurrencyFormatInput';
import FadeOutErrorMessage from '../../commonComponents/util/FadeOutErrorMessage';
import LoadingSpinner from '../../commonComponents/util/LoadingSpinner';
import { formatCurrency, stripCurrencyFormat, formatNumber } from '../../../lib/utils';
import { CampaignListStatuses } from '../../../lib/systemVariables';

const initialState = {
    editMode: false,
    updatedAmount: null,
    updateAttempted: false,
    updateError: false
};

export default class CampaignDetailsListsTableRow extends NavigationComponent {
    constructor(props) {
        super(props);

        this.state = initialState;
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.updating && !nextProps.updating) {
            if (nextProps.updateError) {
                this.setState({ updateError: true });
            } else {
                this.cancelUpdate();
            }
        }
    }

    onChangeAmount(name, value) {
        const updatedAmount = (parseFloat(value || 0) !== parseFloat(this.props.campaignList.defaultAmount || 0))
            ? value : null;
        this.setState({ updatedAmount });
    }

    async updateListAmount() {
        this.setState({ updateAttempted: true, updateError: false });
        if (this.state.updatedAmount > this.props.maxAmount) return;

        this.props.update({ defaultAmount: this.state.updatedAmount });
    }

    cancelUpdate() {
        this.setState(initialState);
    }

    render() {
        const { name, status, statusDisplay, count, manager, fund, defaultAmount, totalCreated, totalPaid, canApprove, canRemove } = this.props.campaignList;

        let statusTag;
        let actionButton;
        switch (status) {
            case CampaignListStatuses.Added:
                statusTag = <button className="btn btn-flat btn-xs btn-flat-status-approved">{statusDisplay}</button>;
                if (canApprove) actionButton = <button className="btn btn-flat-approved btn-xs btn-campaign-status input"
                    disabled={!this.props.canApprove} onClick={() => { if (this.props.canApprove) this.props.approve() }}>
                    <i className="icon-check icon-left input"></i>Approve</button>;
                break;
            case CampaignListStatuses.Approved:
                statusTag = <button className="btn btn-flat btn-xs btn-flat-status-approved">{statusDisplay}</button>;
                actionButton = <span><i className="icon-check icon-left"></i>Approved</span>;
                break;
            case CampaignListStatuses.Sent:
                statusTag = <button className="btn btn-flat btn-xs btn-flat-status-new">{statusDisplay}</button>;
                actionButton = <button className="btn btn-accent2 btn-xs btn-campaign-status input"
                    onClick={this.props.resendMessage}><i className="icon-arrow-right-circle icon-left input"></i>Resend</button>;
                break;
            case CampaignListStatuses.Submitted:
                statusTag = <button className="btn btn-flat btn-xs btn-flat-primary btn-flat-primary-background btn-flat-status-submitted">{statusDisplay}</button>;
                actionButton = <button className="btn btn-primary btn-flat-primary-hover btn-xs btn-campaign-status input"
                    onClick={this.props.verify}><i className="icon-check icon-left input"></i>Verify</button>;
                break;
            default:
                statusTag = null;
                actionButton = null;
        }

        return (
            <HoverTableRow onClick={this.pushRouteWithProps.bind(this,
                `/campaigns/${this.props.campaignId}/lists/${this.props.campaignList.campaignListId}/applications`)}>
                <td data-label="Status">
                    {statusTag}
                </td>
                <td data-label="Name">
                    <p className="bold-text">
                        {name}
                    </p>
                </td>
                <td data-label="Count">
                    <p>{formatNumber(count)}</p>
                </td>
                <td data-label="Manager">
                    <p>{manager}</p>
                </td>
                <td data-label="Fund">
                    <p>{fund}</p>
                </td>
                <td data-label="Default Amount">
                    {this.state.editMode ?
                        <div className="dollar-input-container">
                            <div className="dollar-input">
                                <ValidatedInput input={<CurrencyFormatInput className="input" isIsraeli={this.props.isIsraeli} />}
                                    value={this.state.updatedAmount !== null ? this.state.updatedAmount : (defaultAmount || '')}
                                    onChange={this.onChangeAmount.bind(this)} onKeyDown={e => { if (e.key === 'Enter' && this.state.updatedAmount !== null) this.updateListAmount() }}
                                    validated={true} showValidationError={this.state.updateAttempted}
                                    validate={val => !val || stripCurrencyFormat(val) <= this.props.maxAmount}
                                    errorMessage={`Default amount cannot exceed ${formatCurrency(this.props.maxAmount, this.props.isIsraeli)}.`} />
                            </div>
                            <div className="dollar-input-edit input">
                                {this.props.updating
                                    ? <LoadingSpinner height="12" />
                                    : <div>
                                        <i className={`material-icons input ${this.state.updatedAmount === null ? "disabled" : ""}`}
                                            onClick={this.updateListAmount.bind(this)}>check</i>
                                        <i className="material-icons input" onClick={this.cancelUpdate.bind(this)}>close</i>
                                    </div>}
                            </div>
                            <FadeOutErrorMessage show={this.state.updateError} timeOut={5000} />
                        </div>
                        : <p className="inline-block">
                            {formatCurrency(defaultAmount, this.props.isIsraeli) || `${this.props.isIsraeli ? '₪' : '$'} -`}
                            {(this.props.canUpdate && status !== CampaignListStatuses.Approved) &&
                                <i className="icon-pencil primary-hover icon-right accent-text input" onClick={() => this.setState({ editMode: !this.state.editMode })}></i>}
                        </p>}
                </td>
                <td data-label="Total Created">
                    {totalCreated}
                </td>
                <td data-label="Total Paid">
                    {totalPaid}
                </td>
                {this.props.canUpdate && <td>
                    {actionButton}
                </td>}
                {(this.props.canUpdate && canRemove) && <td data-label="Remove">
                    <i className="icon-trash trash-hover input" onClick={this.props.remove}></i>
                </td>}
            </HoverTableRow>
        );
    };
}


// WEBPACK FOOTER //
// ./src/components/campaignComponents/campaignDetails/CampaignDetailsListsTableRow.jsx